import { useLightMode } from '../utils';
import { Header } from '../components/Header/Header';
import { AnalyticsPanel } from '../components/AnalyticsPanel/AnalyticsPanel';
import s from '../styles/staff.module.css';

// Analytics on its own page. It used to be the queue's second tab, which meant
// it rendered under the day's stats bar — figures about today sitting above a
// chart about a date range nobody had chosen yet.
export function AnalyticsPage() {
  const [lightMode, toggleLightMode] = useLightMode();

  return (
    <div className={lightMode ? `${s.page} ${s.lightPage}` : s.page}>
      <Header lightMode={lightMode} toggleLightMode={toggleLightMode} />
      <AnalyticsPanel light={lightMode} />
    </div>
  );
}
